import React from 'react'
import { checkTextTranslation, checkTranslation, conditionalWidth, translate } from '../../utils/useful'
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import SidebarView from '../SidebarView';
import FormBuilder from '../../windows/FormBuilder';
import Responsive from '../Responsive';
import { FormBuilderObjects } from '../../variables/formBuilderData';
import FormBuilderSidebar from '../pageBuilder2/components/FormBuilderSidebar';
import FormBuilderInputOptions from './FormBuilder/FormBuilderInputOptions';
import StagesManager from '../StagesManager';
import FormBuilderInputConfig from './FormBuilder/FormBuilderInputConfig';
import FormBuilderInputEdit from './FormBuilder/FormBuilderInputEdit';



class FormCreateInput extends React.Component {
    state = {
        fields: [],
        data: [],
        edit: false,
        item: {}
    }

    componentDidMount() {
        this.setState({ fields: this.state.fields });
        // console.log('dataaa-0-0-0-0----0---0-0-0--0-8-8-88888', this.state.data);

    }

    onDragEnd = (result) => {
        console.log("hello", result);
        let items = Array.from(this.state.fields);
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        // return (items);
        this.setState({ fields: items }, () => {
            //   console.log("TP!", this.state.fields);
        });
    };


    filterHandler = () => {
        let fields = [...this.state.fields];
        let temp = [];
        for (let i = 0; i < fields.length; i++) {
            let content = fields[i];
            if (content.item.toLowerCase().includes(this.state.search.toLowerCase())) {
                temp.push(content);
            }
        }
        // console.log(temp);
        this.setState({ fields: temp });
    };

    changeInputValue(value) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }
    openSidebar = () => {
        this.setState({ edit: false })
        this.sidebarView.openSidebar()
    }

    changeStage = (key) => {
        if (this.stagesManager) {
            this.stagesManager.changeStage(key)
        }
    }

    updateInputData = (key, value) => {
        let data = this.state.currentData
        data.information[key] = value
        this.setState({ currentData: data })
    }

    openInputConfig = (header) => {
        // 

        if (this.FormInputConfig) {
            this.FormInputConfig.validateForm((isvalid) => {
                if (!isvalid) {
                    return
                }
                this.openInputConfigAct(header)
            })
        } else {
            this.openInputConfigAct(header)
        }

    }

    openInputConfigAct(header) {

        let sideOpen = header != null ? true : false

        if (sideOpen && header && FormBuilderObjects[header.type]) {


            let data = null

            let formContent = this.state.formContent

            formContent.forEach(page => {
                page.pageContent.forEach(section => {

                    section.sectionContent.forEach(row => {
                        row.rowContent.forEach(input => {
                            if (input.key == header.key) {
                                data = { ...input }
                            }
                        });
                    });
                });
            })
            this.setState({ sideOpen, currentInput: FormBuilderObjects[header.type], currentData: data, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })




        } else {

            this.setState({ sideOpen: false, currentInput: null, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })


        }

    }

    // componentDidUpdate = (state, props) => {

    // }

    setData = (data, cb) => {
        let newData = this.state.data
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }
    setData2 = (data, cb) => {
        console.log('dataaa-0-0-0-0----0---0-0-0--0-8-8-84-4', this.state.data);
        let newDate = this.state.data
        if (!newDate) {
            newDate = {}
        }

        if (data == null) {
            newDate = null
        } else {
            for (const [key, value] of Object.entries(data)) {
                newDate[key] = value
            }
        }
        this.setState({ data: newDate }, () => {
            if (cb) { cb() }
        })
    }



    setField = (data) => {
        let fields = this.state.fields
        let found = false

        fields.forEach((field, index) => {
            if (field.key == data.key) {
                fields[index] = data
                found = true
            }
        });

        if (!found) {
            fields.push(data)
        }

        this.setState({ fields })
        this.sidebarView.close()
    }

    changeItem = (key, value) => {
        this.setState({ [key]: value }, () => {
            console.log('key', key, 'value', value)
        })
    }

    editFormField = (item) => {
        this.changeItem('item', item)
        this.setState({ item })
        this.sidebarView.openSidebar()
        setTimeout(() => {
            this.stageManager.changeStage('edit')
        }, 10);


    }

    render() {
        return (
            <>
                <div className="w-100 h-100">
                    <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                    <div className='w-100 flexc justify-content-end' >
                        <button onClick={() => this.openSidebar()} className='py-1 px-2 br-10 color-white mb-2' style={{ backgroundColor: '#464680' }}>
                            Add New
                        </button>
                    </div>
                    {this.state.fields.length >= 0 && (


                        <div className="flexc scroll-no-scrollbar aa w-100" style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff", maxHeight: "200px" }}>
                            <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <div className="aa w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                                            {console.log('fieldsfieldsfieldsfields-0-0---0-', this.state.fields)}
                                            {Array.isArray(this.state.fields) &&
                                                this.state.fields.map((item, index) => {
                                                    return (
                                                        <>
                                                            <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

                                                            <Draggable key={item.id} draggableId={item.key} index={index}>
                                                                {(provided, snapshot) => {
                                                                    //   console.log("provided", provided, snapshot);
                                                                    if (snapshot.isDragging) {
                                                                        if (!provided.draggableProps) {
                                                                            provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "999" } };
                                                                        }
                                                                        let bound = getBoundingClientRect(this.setPositionDiv.current);
                                                                        const offset = { x: bound.left, y: bound.top };
                                                                        // console.log(offset.x, offset.y)
                                                                        const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                        const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                        // console.log("y:", y, "x:", x);
                                                                        provided.draggableProps.style.left = x;
                                                                        provided.draggableProps.style.top = y;
                                                                        provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                        provided.draggableProps.style.zIndex = "999";
                                                                    }
                                                                    return (
                                                                        <div className="fields-box w-100 br-10" style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                                                                            <div className="fields flexcb br-10 p-2" style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                                                                <div className='flexc'>
                                                                                    <div className='mrd-5' {...provided.dragHandleProps}>
                                                                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                                                                                    </div>
                                                                                    <div className="flexc">
                                                                                        <p className="text-smaller color-muted">{item.information?.label}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div onClick={() => this.editFormField(item)} className='cursor-pointer'>
                                                                                    <img height='15px' src="/images/edit.png" alt="" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }}
                                                            </Draggable>
                                                        </>
                                                    );
                                                })}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    )}
                    {(this.state.fields.length <= 0 || this.state.fields.length == null) && (
                        <div className='w-100 flexcc'>
                            <p>{translate("Found Nothing")}</p>
                        </div>
                    )}
                </div>
                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} sideOpen={false} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "30%", xl: "30%" }}>
                    <div className='scroll-no-scrollbar w-100 h-100'>

                        <StagesManager fast={true} ref={el => this.stageManager = el}>
                            <FormBuilderInputOptions setData={this.setData} formItems={Object.values(FormBuilderObjects)} initData={this.state.data} width={this.props.width} stage={0} stageName={'input type'} changeStage={this.changeStage} selectItem={this.selectItem} services={this.state.services} />
                            <FormBuilderInputConfig setData={this.setData2} setField={this.setField} initData={this.state.data} updateInputData={this.updateInputData} formItems={Object.values(FormBuilderObjects)} headers={this.state.currentInput?.headers} input={this.state.currentInput} clearData={this.clearData} goToFirstStep={this.goToFirstStep} width={this.props.width} stage={1} stageName={'config'} changeStage={this.changeStage} />
                            <FormBuilderInputEdit setField={this.setField} item={this.state.item} initData={this.state.data} updateInputData={this.updateInputData} formItems={Object.values(FormBuilderObjects)} headers={this.state.currentInput?.headers} input={this.state.currentInput} clearData={this.clearData} goToFirstStep={this.goToFirstStep} width={this.props.width} stage={2} stageName={'edit'} changeStage={this.changeStage} />
                        </StagesManager>
                    </div>
                </SidebarView>
            </>
        )
    }
}

export default FormCreateInput;